import { IconSvg, IconSvgProps } from "./icon"

export default function ChevronLeft(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M16.052 20.357 8.145 12.45a.617.617 0 0 1 0-.9l7.907-7.907" />
    </IconSvg>
  )
}
